import { displayEmployeesPage } from "./displays/display-employees-page";
import { deleteActiveEmployees } from "../../infrastructure/employees-cache";
import { findCompanyId } from "../../infrastructure/repository/company-repository";
import { hideModal } from "../commons/hide-modal";
import { showErrorMessage } from "../commons/show-error-message";
import { showSuccessMessage } from "../commons/show-success-message";
import { logError, addContextLog } from "../../infrastructure/log";
import { translate } from "../../infrastructure/translate/localization";
import { redirect } from "../../app/routes/Routes";

export async function removeActiveEmployees({
  employeeId,
  currentPage = 0,
  allowance,
  accumulated,
  forceRefresh = false,
}) {
  try {
    const companyId = await findCompanyId();
    await deleteActiveEmployees({
      companyId,
      payload: {
        operations: [
          {
            employeeId,
            allowance,
            accumulated,
          },
        ],
      },
    }).then(() => {
      if (!forceRefresh) {
        displayEmployeesPage({ currentPage });
      } else {
        redirect("/v2/employees");
      }
    });

    addContextLog("info", "removeActiveEmployees", "request", {
      employeeId,
      companyId,
      allowance,
      accumulated,
    });
    showSuccessMessage(translate("employees-section.delete-employee-success"));
    hideModal();
  } catch (e) {
    logError(e, `Error to removeActiveEmployees employee ${employeeId}`);
    showErrorMessage(translate("common-messages.basic-error-message"), true, e);
  }
}
